import React, { useCallback } from 'react';

import {
  Stack,
  View,
  Logs,
  Log,
  LogComment,
  LogLink,
  LogText,
  LogImage,
} from '@gogame/components';

import { useActionsLog } from 'scenes/Gallery/GalleryPage/Concepts/data';
import CreativeDetails from 'scenes/Gallery/GalleryPage/Creatives/CreativeDetails';

const ActionsLogs = ({ conceptId, openChildComponent }) => {
  const { data, isLoading, isRefetching } = useActionsLog({
    id: conceptId,
  });

  const handleOpenEntity = useCallback(
    ({ id, type }) =>
      () => {
        if (type === 'Creative') {
          openChildComponent(CreativeDetails, { id });
        }
      },
    []
  );

  return (
    <View loading={isLoading} fetching={isRefetching}>
      <Stack pt={2} pb={2} pl={3} pr={3} height={'100%'}>
        <Logs
          empty={!data?.length}
          noResultsProps={{
            inited: !isLoading && !!data,
          }}
        >
          {data?.map((log) => {
            return (
              <Log color={'info'}>
                {log.entityThumbnailUrl && (
                  <LogImage src={log.entityThumbnailUrl} />
                )}

                <LogText
                  date={log.createdDate}
                  user={log.userName}
                  action={log.actionType}
                >
                  {log.comment && <LogComment>{log.message}</LogComment>}
                  <LogLink
                    onClick={handleOpenEntity({
                      id: log.entityId,
                      type: log.entityType,
                    })}
                  >
                    {log.entityName}
                  </LogLink>
                </LogText>
              </Log>
            );
          })}
        </Logs>
      </Stack>
    </View>
  );
};

export default ActionsLogs;
